import * as React from "react";
import { DrawdownIncomeAmendmentModel } from "../../../../../../../Wrap/Models/Models/Processes/Drawdown/DrawdownIncomeAmendmentModel";
import { IProcessComponentProps, ProcessComponent } from "../../../../../../Shared/Process/Process/ProcessComponent";
import { Typography } from "../../../../../../Shared/Typography/Typography";
import { Declarations } from "../Review/Declarations";
import { BankAccount } from "../../../../../../../Wrap/Models/Domains/BankAccount/BankAccount";
import { DrawdownType } from "../../../../../../../Wrap/Constants/Enums/Drawdown/DrawdownType";
import { PensionContributionModel } from "../../../../../../../Wrap/Models/Models/Processes/Apply/Pension/PensionContributionModel";
import { DownloadButton } from "../../../../../../Shared/DownloadButton/DownloadButton";
import { DocumentTaskRequestTypeEnum } from "../../../../../../../Wrap/Constants/Enums/Tasks/DocumentTaskRequestTypeEnum";
import { DocumentsHelper } from "../../../PortfolioDashboard/Components/Document/Resource/DocumentsHelper";
import { getQueryParameters } from "../../../../../../Shared/Wizards/Entities/QueryParametersHelper";
import { processTypeEnum } from "../../../Common/Resource/Contents";
import { HierarchyIdHelper } from "../../../../../../Shared/Common/HierarchyIdHelper";

interface IDocumentsAndDeclarationsProps extends IProcessComponentProps {
    data: PensionContributionModel;
    customerId?: number;
    extraInfo: {
        AllBankAccounts: Array<BankAccount>;
        Drawdowntype: DrawdownType;
    };
}

interface IDocumentsAndDeclarationsState {}

export class DocumentsAndDeclarations extends ProcessComponent<IDocumentsAndDeclarationsProps, IDocumentsAndDeclarationsState> {
    constructor(props: any) {
        super(props);
        this.state = {};
    }

    private getDrawdownIncomeAmendmentModel(): DrawdownIncomeAmendmentModel {
        return this.props.data?.Contribution?.DrawdownIncomeAmendmentModel;
    }

    private renderIncomeIllustration() {
        const clAccountId = getQueryParameters()["claccountid"];
        const clientAccountHierarchyId = getQueryParameters()["subaccounthierarchyid"];
        const instructionId = getQueryParameters()["id"];
        const headAccountHierarchyId = getQueryParameters()["hierarchyid"]
        const illustrationQuery = DocumentsHelper.getTaskRequestForEditIncomeIllustration(
            HierarchyIdHelper.generateHierarchyId(instructionId).entityId,
            clAccountId,
            DocumentTaskRequestTypeEnum.IncomeIllustration,
        );

        const chargesSummaryQuery = DocumentsHelper.getTaskRequest(
            instructionId,
            this.props.customerId.toString(),
            clAccountId,
            headAccountHierarchyId,
            DocumentTaskRequestTypeEnum.ChargeSummary,
            processTypeEnum.OneOffIncomePayment
        )
        
        const config = [
            {
                title: (
                    <div className="mb-24">
                        <a className="hyperlink">Income Illustration</a>
                        <DownloadButton
                            request={illustrationQuery}
                            selectedAccount={clientAccountHierarchyId}
                        ></DownloadButton>
                    </div>
                ),
                data: " ",
            },
            {
                title: (
                    <div className="mb-24">
                        <a className="hyperlink">Charges Summary</a>
                        <DownloadButton
                            request={chargesSummaryQuery}
                            selectedAccount={clientAccountHierarchyId}
                        ></DownloadButton>
                    </div>
                ),
                data: " ",
            }
        ];
        return (
            <>
                <Typography type="wider" wrapCss="narrow-margin no-print" config={config}></Typography>
            </>
        );
    }

    public isValid(): boolean {
        return super.isValid();
    }

    public render(): JSX.Element {
        const { showErrorMsgPopUp } = this.props;
        const data = this.getDrawdownIncomeAmendmentModel();
        return (
            <>
                <h2>Documents</h2>
                {this.renderIncomeIllustration()}
                
                <Declarations
                    data={data}
                    onChange={() => {}}
                    onRef={(ref) => this.appendChild(ref)}
                    showErrorMsgPopUp={(msg, isShow) => showErrorMsgPopUp(msg, isShow)}
                ></Declarations>
            </>
        );
    }
}
